module.exports = __webpack_public_path__ + "img/ghost_body@3x.b272fa88.png";